module.exports = __webpack_public_path__ + "a1857ef67a08e6cad744842628b4e398.svg";